import { createTheme, createVariant, globalTheme } from '@clds/component-theme';
export const popoverTheme = createTheme({
    borderColor: globalTheme.palette.errorAlt,
    byMaxWidth: {
        sm: { maxWidth: '100px' },
        md: { maxWidth: '300px' },
        lg: { maxWidth: '400px' },
        xl: { maxWidth: '600px' },
        none: { maxWidth: 'none' },
    },
    byMinWidth: {
        sm: { minWidth: '100px' },
        md: { minWidth: '200px' },
        lg: { minWidth: '300px' },
        xl: { minWidth: '500px' },
        none: { minWidth: 'none' },
    },
    transition: {
        duration: '200ms',
    },
}, 'popover');
export const popoverMinWidthVariant = createVariant(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => popoverTheme.byMinWidth[props.minWidth || 'none']);
export const popoverMaxWidthVariant = createVariant(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => popoverTheme.byMaxWidth[props.maxWidth || 'none']);
//# sourceMappingURL=theme.js.map